<template>
  <div class="p-24">
    <RevIllustration
      :alt="i18n(translations.modalSubTitle)"
      class="rounded-md max-h-240 w-full object-cover"
      :height="240"
      sizes="327px"
      src="/img/product/jp/sim_unlocked_modal.jpg"
      :width="327"
    />
    <div class="my-24 flex flex-col items-center space-y-16">
      <h2 class="heading-2 text-center">
        {{ i18n(translations.modalSubTitle) }}
      </h2>
      <div>
        <p class="body-1 mb-20">
          {{ i18n(translations.modalDescriptionPart1) }}
        </p>
        <p class="body-1">{{ i18n(translations.modalDescriptionPart2) }}</p>
      </div>
      <RevInfoBlock
        :icon="IconInfo"
        :title="i18n(translations.modalInfoBlockTitle)"
        variant="info"
      >
        <p
          class="body-2"
          :class="[readMore ? 'line-clamp-none' : 'line-clamp-3']"
        >
          {{ i18n(translations.modalInfoBlockContent) }}
        </p>
        <button
          v-if="!readMore"
          class="body-2-bold flex items-center"
          @click="readMore = true"
        >
          {{ i18n(translations.modalInfoBlockReadMore) }}
          <IconChevronDown class="ml-6" />
        </button>
      </RevInfoBlock>
    </div>
    <RevButton full-width="always" :to="finalArticleLink" variant="secondary">{{
      i18n(translations.modalCta)
    }}</RevButton>
  </div>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale } from '#imports'
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconChevronDown } from '@ds/icons/IconChevronDown'
import { IconInfo } from '@ds/icons/IconInfo'
import type { Location } from '@ds/types/Location'

import { CMS } from '~/scopes/cms/routes-names'

import translations from '../../SimUnlockedModal.translations'

const i18n = useI18n()
const resolveLocalizedRoute = useRouteLocationWithLocale()

const props = defineProps<{ articleLink?: Location | string }>()

const readMore = ref(false)

// When used as webview for apps, the link is not passed as prop. For now,
// we replicate the logic here but this should likely be handled externally.
// Something that can be improved under scope of PPI-7883.
const finalArticleLink = computed(() => {
  return (
    props.articleLink ??
    resolveLocalizedRoute({
      name: CMS.ARTICLE,
      params: {
        category: 'smartphones',
        pageName: 'simfree-vs-simlock',
      },
    })
  )
})
</script>
